$(document).on('ready', function() {
    var $form = $('.template-cart #cart-form');

    /////////// Removing cart parsley validation when updating cart
    $form.find('[type="submit"][name="update"]').on('mousedown', function(){
        $form.off('submit.Parsley');
    });
});
